import { Bounce, toast } from "react-toastify";
import Cookies from "universal-cookie";
import { Backend } from "../services/Backend";

export function isUserLoggedIn() {
    const cookie = new Cookies();
    const jwt = cookie.get('jwt');

    return jwt ? true : false;
}

export function isUserAdmin() {
    if (!isUserLoggedIn()) return;
    
    const cookie = new Cookies();
    const jwt = cookie.get('jwt');

    return JSON.parse(atob(jwt.split('.')[1])).role === 'admin';
}

export function SuccessToast(text) {
    toast.success(text, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        });
}

export async function userHasPermissions(permissionKey) {
    var res = await Backend.get(`user/me/has-permission-to/${permissionKey}`);
    return res.status === true;
}